import { createContext } from 'react';

import { useAuthContext } from '@cognite/e2e-auth';
import type { CogniteClient } from '@cognite/sdk';

export interface UseGetViewsByReferencesContextInterface {
  useAuthContext: () => {
    client: {
      views: Pick<CogniteClient['views'], 'retrieve'>;
    };
  };
}

const defaultValue: UseGetViewsByReferencesContextInterface = {
  useAuthContext,
};

export const UseGetViewsByReferencesContext =
  createContext<UseGetViewsByReferencesContextInterface>(defaultValue);
